module.exports = "/_next/static/images/hero-bg-dark-d5a716f7916707a127b6d400b33a2896.png.webp";